module.exports = __webpack_public_path__ + "static/cal.d466b548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cal.jpg
// module id = 1501
// module chunks = 19843951674672